<template>
  <div class="verifyfacecontainer">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'VerifyContainer',
  data() {
    return {
    }
  }
}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>
